import type { FirebaseEnvironment } from "./config";

/** Public API origins used by application callers and the existing Hosting route. */
export const apiEndpoints = {
	stg: {
		publicBaseUrl: "https://ha-api-staging.provoize.com",
		hostingBaseUrl: "https://api.staging.provoize.com",
		regionalBaseUrls: {
			"us-central1": "https://api-spfwunlltq-uc.a.run.app",
			"us-east1": "https://api-spfwunlltq-ue.a.run.app",
		},
	},
	prod: {
		publicBaseUrl: "https://api.provoize.com",
		hostingBaseUrl: "https://api.provoize.com",
		regionalBaseUrls: {
			"us-central1":
				"https://us-central1-call-agents-prod.cloudfunctions.net/api",
			"us-east1": "https://us-east1-call-agents-prod.cloudfunctions.net/api",
		},
	},
} as const satisfies Record<
	FirebaseEnvironment,
	{
		publicBaseUrl: string;
		hostingBaseUrl: string;
		regionalBaseUrls: Record<"us-central1" | "us-east1", string>;
	}
>;
